import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {I18nMessage} from '@shared/api/model/i18n';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnChanges {
  @Input() title: I18nMessage;
  /** Most of the time {@link #title} should be used. Set this only when the title should not be translated. For example,
   * it's a name of a company. */
  @Input() titleStr: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.title && this.titleStr) {
      throw new Error('Cannot set both "title" and "titleStr"');
    }
  }
}
